import axios from 'axios';

export interface IDataCep {
  city: string;
  state: string;
  street: string;
  fullStreet: string;
  location: {
    coordinates: {
      longitude: number;
      latitude: number;
    };
  };
}
const BASE_URL = 'https://brasilapi.com.br/api';

export const getAddressByCep = async (cep: string) => {
  try {
    const url = `${BASE_URL}/cep/v1/${cep}`;
    const data = await axios.get(url).then((response) => {
      return {
        ...response.data,
        fullStreet: response?.data?.street ?? '',
        street: (response?.data?.street?.split('-')?.[0] as string).trim() ?? '',
      };
    });

    return data as IDataCep;
  } catch (error) {
    return undefined;
  }
};
